<template>
<div class="order-from">
    <div class="order-from-content">
        <div class="title">{{language_cut.title}}</div>
        <van-field v-model="name" :placeholder="language_cut.name_placeholder" />
        <!-- <div class="select-class">
            <span>{{select_class}}</span>
            <span>></span>
        </div> -->
        <van-field v-model="phone" :placeholder="language_cut.phone_placeholder" />
        <button class="look-btn" @click="inquire">{{language_cut.btn}}</button>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            name: '',
            phone: '',
            select_class: '选择班级',
            list: '',
            language_cut: {
                title: '',
                name_placeholder: '',
                phone_placeholder: '',
                btn: '',
            },
        }
    },
    created(){
        this.language_cut_fun();
    },
    methods: {
        language_cut_fun(){     // 语言切换
            if(sessionStorage.language == 'en'){
                this.language_cut = {
                    title: 'order inquiry',
                    name_placeholder: 'please enter the student name',
                    phone_placeholder: 'please enter the phone',
                    btn: 'inquiry',
                }
            }else{
                this.language_cut = {
                    title: '订单查询',
                    name_placeholder: '请输入学生姓名',
                    phone_placeholder: '请输入手机号',
                    btn: '查询',
                }
            }
        },
        inquire(){
            if(!this.name){
                let msg = sessionStorage.language == 'ch' ? '请输入学生姓名' : 'please enter the student name'
                this.$notify({ type: 'danger', message: msg });
            }else if(!this.phone){
                let msg = sessionStorage.language == 'ch' ? '请输入手机号' : 'please enter the phone'
                this.$notify({ type: 'danger', message: msg });
            }else if(!this.$commonVariable.phone_regular.test(this.phone)){
                let msg = sessionStorage.language == 'ch' ? '手机号格式不正确' : 'Incorrect phone number format'
                this.$notify({ type: 'danger', message: msg });
            }else{
                this.$service.immediately_buy({
                    mobile: this.phone,
                    passWord: '123123',
                    smsCode: '123456',
                    nickName: '',
                }).then(res => {
                    sessionStorage.setItem('Authorization', res.data.token)
                    this.$service.order_form_list({
                        consignee: this.name,     // 收件人
                        mobile: this.phone,    // 手机号
                    }).then(res => {
                        this.list = res.data.records
                        let order = []
                        this.list.forEach(item => {
                            if(item.items){
                                order.push(item)
                            }
                        })
                        if(order.length <= 0){
                            let msg = sessionStorage.language == 'ch' ? '该手机号未查询到订单' : 'No order was found for this phone number'
                            this.$notify({ type: 'danger', message: msg });
                        }else{
                            sessionStorage.setItem('order',JSON.stringify(order))
                            this.$router.push({
                                path: '/order_form_List',
                            })
                        }
                    })
                }).catch(() => {
                    let msg = sessionStorage.language == 'ch' ? '请求异常' : 'Request exception'
                    this.$notify({ type: 'danger', message: msg });
                })

            }
        },
    },
}
</script>

<style lang="less" scoped>
    .order-from{
        height: 100%;
        display: flex;
        justify-content: center;

        .order-from-content{
            width: 6.4rem;
            height: 4.7rem;
            // height: 5.2rem;
            border-radius: 0.3rem;
            margin-top: 2.5rem;
            background-color: #FFF;
            padding: 0.4rem 0.4rem 0.5rem 0.4rem;
            box-sizing: border-box;

            .title{
                text-align: center;
                color: #696768;
                font-size: 0.32rem;
                margin-bottom: 0.2rem;
            }

            .van-field{
                border-bottom: 0.02rem solid #ECECEC;
            }

            .select-class{
                width: 100%;
                height: 0.9rem;
                box-sizing: border-box;
                padding: 10px 16px;
                color: #C8C9CC;
                font-size: 14px;
                border-bottom: 0.02rem solid #ECECEC;
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .look-btn{
                width: 5.2rem;
                height: 0.6rem;
                margin-top: 0.5rem;
                margin-left: 0.2rem;
                color: #FFF;
                font-size: 0.25rem;
                border-radius: 0.15rem;
                background: linear-gradient(to right, #093268 0%,#062B64 100%);
            }
        }
    }
</style>
